/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count down to any date and time. Pick your target and watch a live tally of the days, hours, minutes and seconds remaining, updating every second.`)
};

const es_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta atrás hasta cualquier fecha y hora. Elige tu objetivo y observa un recuento en vivo de los días, horas, minutos y segundos restantes, actualizándose cada segundo.`)
};

const de_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zähle bis zu einem beliebigen Datum und einer Uhrzeit herunter. Wähle dein Ziel und verfolge live die verbleibenden Tage, Stunden, Minuten und Sekunden — sekündlich aktualisiert.`)
};

const nl_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tel af naar elke datum en tijd. Kies je doel en bekijk een live overzicht van de resterende dagen, uren, minuten en seconden, elke seconde bijgewerkt.`)
};

const fr_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptez à rebours vers n'importe quelle date et heure. Choisissez votre objectif et suivez en direct le décompte des jours, heures, minutes et secondes restants, mis à jour chaque seconde.`)
};

const it_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai un conto alla rovescia verso qualsiasi data e ora. Scegli il tuo obiettivo e guarda un conteggio in tempo reale di giorni, ore, minuti e secondi rimanenti, aggiornato ogni secondo.`)
};

const pt_br2_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça uma contagem regressiva até qualquer data e hora. Escolha o seu alvo e acompanhe ao vivo os dias, horas, minutos e segundos restantes, atualizados a cada segundo.`)
};

const pt_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça a contagem decrescente até qualquer data e hora. Escolha o seu alvo e veja em tempo real os dias, horas, minutos e segundos restantes, atualizados a cada segundo.`)
};

const ja_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任意の日時までカウントダウンします。目標日時を選ぶと、残りの日数・時間・分・秒がリアルタイムに集計され、1秒ごとに更新されます。`)
};

const zh_cd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倒计时到任意日期和时间。选择目标时间，实时查看剩余的天、时、分、秒，每秒自动更新。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_intro", locale)
	if (locale === "en") return en_cd_intro(inputs)
	if (locale === "es") return es_cd_intro(inputs)
	if (locale === "de") return de_cd_intro(inputs)
	if (locale === "nl") return nl_cd_intro(inputs)
	if (locale === "fr") return fr_cd_intro(inputs)
	if (locale === "it") return it_cd_intro(inputs)
	if (locale === "pt-BR") return pt_br2_cd_intro(inputs)
	if (locale === "pt") return pt_cd_intro(inputs)
	if (locale === "ja") return ja_cd_intro(inputs)
	return zh_cd_intro(inputs)
};